import { configureStore } from '@reduxjs/toolkit';
import combineReducers from './combine-reducers';
import { siteApi } from 'services/siteApi';
import 'services/shoppingCartApi'; //Ensure injectEndpoints runs before the store is used

const DEV_DEFAULT_TRACE_LIMIT = 10;

const store = configureStore({
  reducer: combineReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(siteApi.middleware),
  devTools:
    process.env.NODE_ENV === 'development'
      ? {
          trace:
            process.env.REACT_APP_DEV_TRACE === 'TRUE' && process.env.REACT_APP_ENV === 'local',
          traceLimit: Number(process.env.REACT_APP_DEV_TRACE_LIMIT) || DEV_DEFAULT_TRACE_LIMIT,
        }
      : false,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
